export const Images = {
    logo: require("./Images/logo.png"),
    wordmark: require("./Images/wordmark.png"),
    reviews: require("./Images/reviews.jpg"),
    2: require("./Images/2.jpg"),
    1: require("./Images/1.jpg"),
    3: require("./Images/3.png"),
    C1: require("./Images/C1.png"),
    C2: require("./Images/C2.png"),
    C3: require("./Images/C3.png"),
    C4: require("./Images/C4.png"),
    residential: require("./Images/residential.png"),
    commercial: require("./Images/commercial.png"),
    termite: require("./Images/termite.jpg"),
    rodent: require("./Images/rodent.png"),
    bed: require("./Images/bed.png"),
    eco: require("./Images/eco.png"),
    work: require("./Images/work.png"),
    contact: require("./Images/contact.png"),
    about: require("./Images/about.png"),
    ant: require("./Images/ant.png"),
    Locations: require("./Images/Locations.png"),

}